/**
 * Typesafe method overload that allows using of typeguards in array.filter.
 */
interface Array<T> {
  filter<U extends T>(pred: (a: T) => a is U): U[];
}
/**
 * moves an item in an array to the given index
 * @param arr
 * @param oldIndex
 * @param newIndex
 * @returns {array} returns new sorted array
 */
export const moveArrayItemToNewIndex = <T>(
  arr: (T | undefined)[],
  oldIndex: number,
  newIndex: number
): Array<T | undefined> => {
  let oldI = oldIndex;
  let newI = newIndex;

  const newArray = [...arr];

  while (oldI < 0) {
    oldI += newArray.length;
  }
  while (newI < 0) {
    newI += newArray.length;
  }
  if (newI >= newArray.length) {
    let k = newI - newArray.length;
    while ((k -= 1) + 1) {
      newArray.push(undefined);
    }
  }
  newArray.splice(newI, 0, newArray.splice(oldI, 1)[0]);
  return newArray;
};

export const fileListToArray = (fileList: FileList | null): File[] => {
  return fileList ? Array.from(fileList) : [];
};
